<template>
    <div class="container">
        <van-image 
            class="heade-iamge"
            lazy-load
            :src="imageList[0]"
        />


        <ul class="render-box" >
            
            <li v-touch:tap.prevent="showPopup" class="render-item f-s-b set-out-box">
                <div class="set-out-txt">导航去博物馆</div>
                <van-image 
                    class="heade-iamge"
                    lazy-load
                    :src="imageList[2]"
                />
            </li>

            <li v-touch:tap="goToMap(1)" class="render-item f-s-b ground-floor">
                <div class="floor-nuber f-c">1F</div>
                <ul class="floor-info-render-box f-s-b">
                    <li class="info-row">1号厅</li>
                    <li class="info-row">2号厅</li>
                    <li class="info-row">3号厅</li>
                </ul>
            </li>

            <li v-touch:tap="goToMap(2)" class="render-item f-s-b second-floor">
                <div class="floor-nuber f-c">2F</div>
                <ul class="floor-info-render-box f-s-b">
                    <li class="info-row f-s-b">
                        <div>3号展厅</div>
                        <div class="iconfont iconjiantouarrow487"></div>
                        <div class="samll-font">
                            <div>木中皇后</div>
                            <div class="below-font">海南黄花梨陈列</div>
                        </div>
                    </li>
                    <li class="info-row f-s-b">
                        <div>4号展厅</div>
                        <div class="iconfont iconjiantouarrow487"></div>
                        <div class="samll-font">
                            <div>香中魁首</div>
                            <div class="below-font">海南沉香陈列</div>
                        </div>
                    </li>
                    <li class="info-row f-s-b">
                        <div>5号展厅</div>
                        <div class="iconfont iconjiantouarrow487"></div>
                        <div class="samll-font">
                            <div>土火之艺</div>
                            <div class="below-font">馆藏古代陶瓷展</div>
                        </div>
                    </li>
                </ul>
            </li>

            <li v-touch:tap="goToMap(3)" class="render-item f-s-b third-floor">
                <div class="floor-nuber f-c">3F</div>
                <ul class="floor-info-render-box f-s-b">
                    <li class="info-row">
                        <div class="title">非遗四个一</div>
                        <div class="desc">海南非物质文化遗产</div>
                    </li>
                    <li class="info-row f-s-b">
                        <div class="name">6号展厅</div>
                        <div class="iconfont iconjiantouarrow487"></div>
                        <div class="samll-font">
                            <div>琼工坊</div>
                            <div class="below-font">海南传统手工技艺陈列</div>
                        </div>
                    </li>
                    <li class="info-row f-s-b">
                        <div class="name">7号展厅</div>
                        <div class="iconfont iconjiantouarrow487"></div>
                        <div class="samll-font">
                            <div>琼肴街</div>
                            <div class="below-font">海南饮食文化陈列</div>
                        </div>
                    </li>
                    <li class="info-row f-s-b">
                        <div class="name">8号展厅</div>
                        <div class="iconfont iconjiantouarrow487"></div>
                        <div class="samll-font">
                            <div>琼崖村</div>
                            <div class="below-font">海南少数名族非物质文化遗产陈列</div>
                        </div>
                    </li>
                    <li class="info-row f-s-b">
                        <div class="name">9号展厅</div>
                        <div class="iconfont iconjiantouarrow487"></div>
                        <div class="samll-font">
                            <div>琼戏台</div>
                            <div class="below-font">琼州表演艺术陈列</div>
                        </div>
                    </li>
                </ul>
            </li>

            <li class="back-btn f-c" v-touch:tap="back">
                <div class="iconhebei iconfanhui"></div>
                <div>返回非遗园区导航</div>
                <van-image 
                    class="swipe-itme"
                    lazy-load
                    :src="imageList[1]"
                />
            </li>

        </ul>


        <van-popup
            v-model="show"
            round
            position="bottom"
            :style="{ height: '35%' }"
            :close-on-popstate="true"
        >
            <van-picker 
                show-toolbar
                title="选择导航地图"
                confirm-button-text="出发"
                @cancel="showPopup"
                @confirm="setOut"
                :columns="columns" 
            />
        </van-popup>

    </div>
</template>

<script>
    import { 
        Popup,
        Picker,
    } from 'vant';
    export default {
        data() {
            return {
                imageList: [
                    // require('@image/home/map-bg.png'),
                    require('@image/home/map-bg.jpg'),
                    require('@image/home/1.png'),
                    require('@image/home/set-out.png'),
                ],
                show: false,
                columns: [
                    '高德地图',
                    '腾讯地图',
                    '百度地图',
                ]
            }
        },
        methods: {
            back(){
                // this.$router.go(-1);
                this.$router.push({ name: "Home" })
            },
            goToMap(floor){
                return ()=>{
                    this.$router.push({ name: 'drawingMap', query: { floor } })
                }
            },
            showPopup() {
                this.show = !this.show;
            },

            setOut(value,index){
                switch(index){
                    //  高德地图
                    case 0 : return window.location.href = `http://uri.amap.com/marker?position=${110.379051},${20.015266}&name=海南省博物馆&coordinate=${110.379051,20.015266}&callnative=1`;
                    //  腾讯地图
                    case 1 : return window.location.href = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${20.015266},${110.379051};addr:${110.379051,20.015266}`;
                    //  百度地图  
                    case 2 : return window.location.href = `http://api.map.baidu.com/marker?location=${20.021773},${110.385478}&title=海南省博物馆&content=海口市琼山区国兴大道68号&output=html`;
                }
            },



        },
        components:{
            [Popup.name]: Popup,
            [Picker.name]: Picker,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        background-color: #ffffff !important;
        position: relative;
        .heade-iamge{
            width: 100%;
            // position: absolute;
            // left: 0;
            // right: 0;
            // top: 0;
            // bottom: 0;
            // z-index: 0;
        }
        .render-box{
            position: absolute;
            left: 12px;
            right: 12px;
            top: 0;
            top: 135px;
            margin-bottom: 10px;
            .render-item{
                justify-content: flex-start;
                margin-bottom: 10px;
                .iconfont{
                    color: #602F04;
                    margin: 0 5px;
                }
                &:last-of-type{
                    margin: 0;
                }
                .floor-nuber{
                    width: 80px;
                    font-size: 33px;
                    font-weight: bold;
                    color: #ffffff;
                    border-right: 1px solid #ffffff;
                }
                .floor-info-render-box{
                    width: ~'calc(100% - 80px)';
                    padding: 0 28px;
                    color: #000000;
                }
            }
            .ground-floor{
                height: 65px;
                background-color: #90E3A6;
            }
            .second-floor{
                // height: 130px;
                align-items: flex-start;
                padding: 15px 0 ;
                background-color: #FF956D;
                .floor-info-render-box{
                    align-items: flex-start;
                    flex-direction: column;
                    .info-row{
                        margin-bottom: 15px;
                        &:last-of-type{
                            margin: 0;
                        }
                        .samll-font{
                            font-size: 12px;
                            font-weight: 400;
                            border-left: 2px solid #000000;
                            padding-left: 5px;
                            .below-font{
                                font-size: 8px !important;
                                font-weight: 200;
                            }
                        }
                    }
                }
            }
            .third-floor{
                // height:230px;
                background-color: #72ABD4;
                align-items: flex-start;
                padding: 15px 0 ;
                .floor-info-render-box{
                    // padding-right: 0;
                    align-items: flex-start;
                    flex-direction: column;
                    .info-row{
                        margin-bottom: 15px;
                        &:last-of-type{
                            margin: 0;
                        }
                        .iconfont{
                            color: #3C5294;
                        }
                        .title{
                            font-size: 19px;
                            font-weight: bold;
                        }
                        .desc{
                            font-weight: 200;
                            font-size:12px;
                        }
                        .name{
                            white-space: nowrap;
                        }
                        .samll-font{
                            font-size: 12px;
                            font-weight: 400;
                            border-left: 2px solid #3C5294;
                            padding-left: 5px;
                            .below-font{
                                font-size: 8px !important;
                                font-weight: 200;
                            }
                        }
                    }
                }
            }
            .back-btn{
                position: relative;
                z-index: 5;
                color: #1970AE;
                font-weight: 400;
                margin-top: -20px;
                .iconhebei{
                    margin-right: 5px;
                }
                .swipe-itme{
                    width: 99px;
                }
            }
        }
        .set-out-box{
            position: relative;
            .set-out-txt{
                position: absolute;
                top: 50%;
                font-size: 15px;
                font-weight: 500;
                transform: translateY(-40%);
                left: 20px;
                z-index: 5;
                color: #4b4846;
                text-shadow:#ffffff 1px 0 0,#ffffff 0 1px 0,#ffffff -1px 0 0,#ffffff 0 -1px 0;
                -webkit-text-shadow:#ffffff 1px 0 0,#ffffff 0 1px 0,#ffffff -1px 0 0,#ffffff 0 -1px 0;
                -moz-text-shadow:#ffffff 1px 0 0,#ffffff 0 1px 0,#ffffff -1px 0 0,#ffffff 0 -1px 0;
                filter: Glow(color=#ffffff, strength=1);
            }
        }
    }
</style>